import { createRouter, createWebHistory } from "vue-router";
import { createAppRoutes, modernNotFoundPath } from "./routes";

export function createModernRouter() {
  return createRouter({
    history: createWebHistory(),
    routes: createAppRoutes({ notFoundPath: modernNotFoundPath }),
  });
}
